import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import loaderAnimation from "../../../assests/loader.json";

const Loader = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: loaderAnimation,
    });

    return () => anim.destroy();
  }, []);

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "calc(100% - 300px)",
      height: "100%",
      background: "rgb(255 255 255 / 66%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      marginLeft: "300px",
    }}>
      <div
        ref={containerRef}
        // ✅ Lottie jo SVG render karta hai usse target karo
        className="lottie-container"
      />

      {/* Global style SVG ke liye */}
      <style>{`
        .lottie-container svg {
          max-width: 300px !important;
        }
      `}</style>
    </div>
  );
};

export default Loader;


// WEBPACK FOOTER //
// src/modules/employee/Inbox/components/Loader.js